module.exports = "/packs/images/home/device-with-pods-ae43c1d45dd6370cf72aa4ab8379163a.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/home/device-with-pods.png
// module id = 1647
// module chunks = 0